<p-dialog
	[visible]="visible"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[dismissableMask]="dismissableMask"
	[closeOnEscape]="closeOnEscape"
	[closable]="showCloseButton"
	[showHeader]="!hideHeader"
	[style]="{ width: width }"
	[breakpoints]="breakpoints"
	[styleClass]="styleClassName"
	(onHide)="onClose()"
>
	<ng-template pTemplate="header" *ngIf="!hideHeader">
		<header class="ui-dialog__header" data-test="ui-dialog-header">
			<h2 class="ui-dialog__title">{{ title | translate }}</h2>
		</header>
	</ng-template>

	<section class="ui-dialog__content" data-test="ui-dialog-content">
		<ng-content></ng-content>
	</section>

	<ng-template pTemplate="footer" *ngIf="!hideFooter">
		<footer class="ui-dialog__footer" data-test="ui-dialog-footer">
			<button
				*ngIf="secondaryLabel"
				type="button"
				class="ui-dialog__btn ui-dialog__btn--secondary"
				(click)="onSecondaryAction()"
				data-test="ui-dialog-secondary"
			>
				{{ secondaryLabel | translate }}
			</button>

			<button
				type="button"
				class="ui-dialog__btn ui-dialog__btn--primary"
				(click)="onPrimaryAction()"
				data-test="ui-dialog-primary"
			>
				{{ primaryLabel | translate }}
			</button>
		</footer>
	</ng-template>
</p-dialog>
